import React, {Component} from "react";
import {connect} from "react-redux";
import ModuleList from "./ModuleList.js";
import LoginForm from "./LoginForm.js";
import Slogan from "./Slogan.js";
import VideoPlayerWrapper from "./VideoPlayerWrapper.js";
import OpenList from "./OpenList.js";
import VideoList from "./VideoList.js";

class Home extends Component {
    render() {
        if (this.props.cookieChecker) {
            return (
                <div className="safari-fallback">
                    <div className="row">
                        <div className="col-md-4"/>
                        <div className="col-md-4 text-center">
                            <img src="/img/safari_bug.jpg" alt="Safari bug"
                                 className="img-responsive center-block col-centered"/>
                        </div>
                        <div className="col-md-4"/>
                    </div>
                    <div className="row">
                        <div className="col-md-1"/>
                        <div className="col-md-10 text-center">
                            <h2>Limitation imposed by some Safari settings are preventing this website from working normally<br /><br /></h2>
                            <h1>Please follow the following procedure to make this website working on Safari<br /></h1>
                            <h2>First, open Safari preferences</h2>
                            <img src="/img/safari-step1.png" alt="Safari step1"
                                 className="img-responsive center-block col-centered"/>
                            <h2>Second, choose "Always allow" for Cookies and website data under Privacy Tab</h2>
                            <img src="/img/safari-step2.png" alt="Safari step2"
                                 className="img-responsive center-block col-centered"/>
                            <h2>Finally, refresh this page, and you are done!</h2>
                            <img src="/img/safari-step3.png" alt="Safari step3"
                                 className="img-responsive center-block col-centered"/>
                            <h2>Of course, you can switch to Chrome to get the best experience!</h2>
                            <a href="https://www.google.com/chrome/"><img src="/img/chrome.png" alt="Chrome"
                                                                          className="img-responsive center-block col-centered"/></a>
                            <h2>We apologize for the inconvenience caused.</h2>
                        </div>
                        <div className="col-md-1"/>
                    </div>
                </div>
            );
        }
        let home;
        if (this.props.user) {
            home = (
                <div>
                    <div className="mt-2">
                        <ModuleList />
                        {<VideoList type="Recent" videos={this.props.miscVideos.recent}/>}
                        <OpenList />
                        {<VideoList type="Trending" videos={this.props.miscVideos.trending}/>}
                        {<VideoList type="New" videos={this.props.miscVideos.latest}/>}
                    </div>
                </div>
            );
        } else {
            home = (
                <div>
                    <div className="home">
                        <div className="login-form-col">
                            <div className="jumbotron">
                                <Slogan />
                                <LoginForm />
                            </div>
                        </div>
                        <VideoPlayerWrapper />
                    </div>
                </div>
            );
        }
        return home;
    }
}
let mapStateToProps = (state) => {
    return {
        user: state.user,
        miscVideos: state.miscVideos,
        cookieChecker: state.cookieChecker
    };
};
export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./src/componentsBody/Home.js